'use client';

import { c as _c } from "react/compiler-runtime";
import { TooltipButton } from '@/comps/tooltip-button';
import { formatPercentage } from '@/utils/format.util';
import { cn } from '@/utils/shad';
import { PieChart } from 'lucide-react';
type PageShareChipProps = {
  /** Share of the column total, on the decimal scale. */
  share: number;
  tooltip?: string;
  className?: string;
};

/** Bordered pie pill beside a table number, matching the analytics datatable share chips. */
export function PageShareChip(t0) {
  const $ = _c(13);
  const {
    share,
    tooltip,
    className
  } = t0;
  const t1 = tooltip ?? "Percentage over the total of the column.";
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex shrink-0 items-center gap-0.75 rounded-base border px-1 py-0.75 text-[10px] leading-3 text-muted-foreground", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PieChart size={12} className="shrink-0 text-bluev2" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== share) {
    t4 = formatPercentage(share, {
      inputScale: "decimal",
      decimals: 0
    });
    $[3] = share;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span>{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t6) {
    t7 = <TooltipButton content={t1}>{t6}</TooltipButton>;
    $[10] = t1;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}